<div class="generalPage mt-3rem ml-6 mr-1rem print-content print-all-content">
  <h1 class="top-heading content-blue">{{header}}</h1>
  <span id="Publiccomment" [innerHtml]="guidecontent" (click)="openLinkById($event)" (contextmenu)="onRightClick($event)"></span>
</div>
